import { render, staticRenderFns } from "./ProjectMemberBox.vue?vue&type=template&id=c45e947a"
import script from "./ProjectMemberBox.vue?vue&type=script&lang=ts"
export * from "./ProjectMemberBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports